import { Cache } from "@siteimprove/alfa-cache";
import { Node } from "../../node.js";
import { Element } from "../element.js";
const _descendantsCache = Cache.empty();
export function getDescendants(predicate) {
    return (node, options = Node.Traversal.empty) => {
        const optionsMap = _descendantsCache
            .get(predicate, Cache.empty)
            .get(node, () => []);
        if (optionsMap[options.value] === undefined) {
            optionsMap[options.value] = node.descendants(options).filter(predicate);
        }
        return optionsMap[options.value];
    };
}
/**
 * @public
 */
export const getElementDescendants = getDescendants(Element.isElement);
/**
 * @public
 */
export function getInclusiveElementDescendants(node, options = Node.Traversal.empty) {
    return getElementDescendants(node, options).prepend(node);
}
//# sourceMappingURL=descendants.js.map